import React, { useEffect, useState, useRef } from "react";
import moment from "moment";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { get, head, map, filter, isEmpty } from "lodash";
import { useHistory, useParams } from "react-router-dom";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableContainer,
} from "@material-ui/core";
import Menu from "@material-ui/core/Menu";

import MenuItem from "@material-ui/core/MenuItem";
import IconButton from "@material-ui/core/IconButton";
import MoreVertIcon from "@material-ui/icons/MoreVert";

import { makeStyles, withStyles } from "@material-ui/core/styles";

import { AddressSearch } from "./AddressSearch";
import { confirmModal } from "../../v2_actions/ui";
import {
  galleryList, galleryDetailedList, replicateGalleryList, DEFAULT_NUM_ITEMS_PER_GALLERY_PAGE
} from "../../v2_actions/gallery";
import LoadingSpinner from "../../components/LoadingSpinner";
import { SideBarGalleryFilter } from "./SideBarGalleryFilter";
import { replaceSpacesWithDashes } from "v2_actions/nav";
import { showSuccess, showError } from "../../v2_actions/error";
import { setSelectedGallery, setEditingGallery, setAddingPhotos } from "../../actions/gallery";
import { photographerLedgerList } from "../../v2_actions/photographer_ledger";
import { getDefaultLocationForUser, setMapCenter } from "../../v2_actions/map";
import { facialRecognitionList } from "../../v2_actions/facial_recognition";
import { bibNumberRecognitionList } from "../../v2_actions/bib_recognition"
import { processGalleryPhotographsList } from "v2_actions/process_gallery_photographs";
import Pagination from "../TablePagination";

const StyledTableCell = withStyles((theme) => ({
  head: {
    fontSize: 12,
    letterSpacing: "0.08em",
    textTransform: "uppercase",
    fontWeight: 800,
    color: "#0b3556",
    backgroundColor: "#fff",
    borderBottom: "1px solid #d6e2ef",
    borderTop: "none",
    borderLeft: "none",
    borderRight: "none",
    padding: "10px 16px",
    textAlign: "left",
    position: "sticky",
    top: 0,
    zIndex: 1,
  },
  body: {
    fontSize: 13,
    fontWeight: 400,
    color: "#4a4a48",
    textAlign: "left",
    padding: "15px 16px",
    borderBottom: "1px solid #e6eef7",
    borderTop: "none",
    borderLeft: "none",
    borderRight: "none",
    verticalAlign: "middle",
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    backgroundColor: "#fff",
    cursor: "pointer",
    transition: "background 0.12s",
    height: 40,
    "& td:nth-child(1), & th:nth-child(1)": {
      fontSize: 12,
      color: "#4a4a48",
      whiteSpace: "nowrap",
    },
    "& td:nth-child(2)": {
      fontWeight: 600,
      color: "#2c2c2c",
    },
    "& td:nth-child(3)": {
      fontSize: 12.5,
      color: "#4a4a48",
      textAlign: "center",
      fontVariantNumeric: "tabular-nums",
    },
    "& td:nth-child(4)": {
      fontSize: 12.5,
      color: "#4a4a48",
    },
    "& td:nth-child(5)": {
      textAlign: "right",
      paddingRight: 12,
    },
    "&.unavailable td, &.unavailable th": {
      color: "#bec5cd",
      fontWeight: 400,
    },
    "&:hover": {
      backgroundColor: "#f4f8fd",
    },
    "&.Mui-selected, &.Mui-selected.MuiTableRow-root": {
      backgroundColor: "#e7f0fa !important",
    },
    "&.Mui-selected:hover, &.Mui-selected.MuiTableRow-root:hover": {
      backgroundColor: "#dde9f6 !important",
    },
    "&.Mui-selected td": {
      color: "#0b3556",
    },
    "&.Mui-selected td:first-child, &.Mui-selected th:first-child": {
      position: "relative",
    },
    "&.Mui-selected td:first-child::before, &.Mui-selected th:first-child::before": {
      content: '""',
      position: "absolute",
      left: -8,
      top: 4,
      bottom: 4,
      width: 4,
      borderRadius: "0 3px 3px 0",
      background: "#3a86d8",
    },
  },
}))(TableRow);

const useStyles = makeStyles((theme) => ({
  container: {
    zIndex: 99,
    position: "relative",
    padding: 0,
    background: "#fff",
    border: "1px solid #d6e2ef",
    borderRadius: 14,
    boxShadow: "0 1px 2px rgba(11,53,86,0.04)",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    height: "calc(100vh - 95px)",
  },
  tableWrap: {
    flex: 1,
    minHeight: 0,
    overflowY: "auto",
    overflowX: "hidden",
    paddingLeft: 8,
  },
  unavailable_to_purchase_gallery: {
    "& $nameCell": {
      color: "#aab3bd",
    },
    "& $dateCell": {
      color: "#aab3bd",
    },
  },
  dateCell: {
  },
  nameCell: {
  },
  clickIcon: {
    cursor: "pointer",
  },
  actionWrapper: {
    top: "70px",
    right: "10px",
    position: "absolute",
  },
}));

function format(x) {
  return Number.parseFloat(x).toFixed(2);
}

const SelectRow = ({
  row,
  history,
  dispatch,
  onDeleted,
  onAvailableToPurchase,
  onUnavailableToPurchase,
}) => {
  const gallery_id = get(row, "id");
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedValue, setSelectedValue] = useState(false);

  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = (event) => {
    setAnchorEl(null);
    setSelectedValue(event.target.getAttribute("value"));

    // Get attribute value from selected option
    let value = event.target.getAttribute("value");
    if (value === "EDIT") {
      dispatch(galleryDetailedList.get({galleryRef: gallery_id})).then((fullGallery) => {
        dispatch(setEditingGallery(fullGallery));
      });
    }
    if (value === "ADD_PHOTOS") {
      dispatch(setAddingPhotos(row));
    }
  };

  const onCopyGalleryUrlToClipboard = (row) => {
    const galleryDbId = get(row, "db_id");
    const gallerySessionName = replaceSpacesWithDashes(
      get(row, "session_name"),
    );
    const galleryUrl = `${window.location.origin}/customer/gallery/${gallerySessionName}/${galleryDbId}`;

    navigator.clipboard
      .writeText(galleryUrl)
      .then(showSuccess("Success", "Gallery name copied to clipboard"));
  };
  const onRunFacialRecognition = (row) => {
    const galleryId = get(row, "id");
    dispatch(facialRecognitionList.indexGalleryForFacialRecognition(galleryId));
    showSuccess("Running");
  };

  const onIndexBibRecognition = (row) => {
    const galleryId = get(row, "id");
    dispatch(bibNumberRecognitionList.indexGallery(galleryId))
    showSuccess("Indexing")
  }

  const onProcessGalleryPhotographs = (row) => {
    const galleryId = get(row, "id");
    dispatch(
      processGalleryPhotographsList.processGalleryPhotographs(galleryId),
    );
  };

  return (
    <div>
      <IconButton
        aria-label="more"
        id="long-button"
        aria-controls={open ? "long-menu" : undefined}
        aria-expanded={open ? "true" : undefined}
        aria-haspopup="true"
        onClick={handleClick}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="long-menu"
        anchorEl={anchorEl}
        keepMounted
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            // maxHeight: ITEM_HEIGHT * 4.5,
            width: "20ch",
          },
        }}
        // Should Open in bottom left side
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <MenuItem
          onClick={() => {
            history.push(`/photographer/gallery/${gallery_id}/view`);
          }}
          value="VIEW"
        >
          View Photos
        </MenuItem>
        <MenuItem onClick={handleClose} value="EDIT">
          Edit Gallery
        </MenuItem>
        <MenuItem value="ADD_PHOTOS" onClick={handleClose}>
          Add Photos
        </MenuItem>
        <MenuItem
          value="COPY_URL"
          onClick={(e) => {
            onCopyGalleryUrlToClipboard(row);
            handleClose(e);
          }}
        >
          Copy Gallery Url
        </MenuItem>
        <MenuItem
          value="RUN_FACIAL_RECOGNITION"
          onClick={(e) => {
            onRunFacialRecognition(row);
            handleClose(e);
          }}
        >
          Run Facial Recognition
        </MenuItem>
        <MenuItem
          value="INDEX_BIB_RECOGNITION"
          onClick={(e) => {
            onIndexBibRecognition(row);
            handleClose(e);
          }}
        >
          Index Bib Recognition
        </MenuItem>
        <MenuItem
          value="PROCESS_GALLERY_PHOTOGRAPHS"
          onClick={(e) => {
            onProcessGalleryPhotographs(row);
            handleClose(e);
          }}
        >
          Process Gallery Photographs
        </MenuItem>
        <MenuItem
          onClick={(e) => {
            onDeleted(row);
            handleClose(e);
          }}
          value="DELETE"
        >
          Delete Gallery
        </MenuItem>
        <MenuItem
          onClick={(e) => {
            onUnavailableToPurchase(row);
            handleClose(e);
          }}
          value="UNAVAILABLE_TO_PURCHASE"
        >
          Unpublish Gallery
        </MenuItem>
        <MenuItem
          onClick={(e) => {
            onAvailableToPurchase(row);
            handleClose(e);
          }}
          value="AVAILABLE_TO_PURCHASE"
        >
          Publish Gallery
        </MenuItem>
        <MenuItem
          value="COPY"
          onClick={(e) => {
            const galleryName = row.session_name || row.gallery_name;
            dispatch(confirmModal({
              title: "Copy Gallery",
              text: "Enter new gallery name",
              inputField: {
                defaultValue: `${galleryName} copy`,
              },
              onConfirmed: (newSessionName) => {
                dispatch(replicateGalleryList.replicate({galleryRef: gallery_id, sessionName: newSessionName})).then(() => {
                  dispatch(galleryList.invalidateList());
                  dispatch(galleryList.fetchListIfNeeded());
                  dispatch(confirmModal({
                    title: "Gallery Copied",
                    text: `Your gallery, ${newSessionName}, has been created. Please "Edit Gallery" if you need to change any credentials and "Add Photos" when you are ready.`,
                    onConfirmed: () => {},
                    can_cancel: false,
                  }));
                });
              },
              can_cancel: true,
            }));
            handleClose(e);
          }}
        >
          Copy Gallery
        </MenuItem>
      </Menu>
    </div>
  );
};

const AllGalleries = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [isBusy, setIsBusy] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [age, setAge] = React.useState("");
  const hasAutoSelectedFirstGallery = useRef(false);
  const history = useHistory();
  const galleries = useSelector(() => galleryList.getVisibleObjects());
  const loadingGalleries = useSelector(() => galleryList.isLoading());
  const galleries_excluding_photoart = filter(
    galleries,
    (gallery) => gallery.gallery_type !== "photo_art",
  );

  const formProps = useForm({});
  const {
    handleSubmit,
    control,
    clearErrors,
    reset,
    getValues,
    setValue,
    formState: { errors },
  } = formProps;

  const onDeleteSelectedGallery = (json) => {
    const onDeleted = (json) => {
      if (json.errors) {
        showError("Error", JSON.stringify(json.errors));
      } else {
        dispatch(galleryList.invalidateList());
        dispatch(galleryList.fetchListIfNeeded());
        showSuccess("Success", "Gallery deleted");
        setIsBusy(false);
      }
    };

    const onConfirmed = () => {
      setIsBusy(true);
      dispatch(galleryList.deleteObject(json.id)).then(onDeleted);
    };

    dispatch(
      confirmModal({
        can_cancel: true,
        onConfirmed: onConfirmed,
        text: "Are you sure you want to delete this gallery?",
      }),
    );
  };

  const onUnavailableToPurchaseSelectedGallery = (json) => {
    const onUnavailableToPurchase = (json) => {
      if (json.errors) {
        showError("Error", JSON.stringify(json.errors));
      } else {
        dispatch(galleryList.invalidateList());
        dispatch(galleryList.fetchListIfNeeded());
        showSuccess("Success", "Gallery unavailable to purchase");
        setIsBusy(false);
      }
    };

    const onConfirmed = () => {
      const values = Object.assign({}, json, {
        available_to_purchase: false,
      });
      setIsBusy(true);
      dispatch(galleryList.saveObject(values)).then(onUnavailableToPurchase);
    };

    dispatch(
      confirmModal({
        can_cancel: true,
        onConfirmed: onConfirmed,
        text: "Are you sure you want to make this gallery unavailable to purchase?",
      }),
    );
  };

  const onAvailableToPurchaseSelectedGallery = (json) => {
    const onAvailableToPurchase = (json) => {
      if (json.errors) {
        showError("Error", JSON.stringify(json.errors));
      } else {
        dispatch(galleryList.invalidateList());
        dispatch(galleryList.fetchListIfNeeded());
        showSuccess("Success", "Gallery available to purchase");
        setIsBusy(false);
      }
    };

    const onConfirmed = () => {
      const values = Object.assign({}, json, {
        available_to_purchase: true,
      });
      setIsBusy(true);
      dispatch(galleryList.saveObject(values)).then(onAvailableToPurchase);
    };

    dispatch(
      confirmModal({
        can_cancel: true,
        onConfirmed: onConfirmed,
        text: "Are you sure you want to make this gallery available to purchase?",
      }),
    );
  };
  const showMenu = useSelector((state) => state.user.showMenu);
  const handleChange = (event) => {
    setAge(event.target.value);
  };

  useEffect(() => {
    dispatch(photographerLedgerList.fetchListIfNeeded());
  }, []);

  const { gallery_id } = useParams();
  const gallery = useSelector(() => galleryList.getObject(gallery_id));
  const is_ready = !gallery_id || get(gallery, "id");
  const selectedGallery = useSelector((state) => state.gallery.selectedGallery)

  useEffect(() => {
    if (get(gallery, "lat") && get(gallery, "lng")) {
      dispatch(
        setMapCenter({ lat: get(gallery, "lat"), lng: get(gallery, "lng") }),
      );
    }
  }, [get(gallery, "id")]);

  useEffect(() => {
    // Set pagination before fetching to ensure only 20 items are loaded initially
    dispatch(galleryList.updatePaginationNumItemsPerPage(DEFAULT_NUM_ITEMS_PER_GALLERY_PAGE));
    dispatch(galleryList.fetchListIfNeeded());
    if (gallery_id) {
      dispatch(galleryList.ensureObjectLoaded(gallery_id));
    }
  }, [gallery_id]);

  const selectGalleryWithDetail = (galleryId) => {
    if (galleryId === selectedRowId) {
      return;
    }
    setSelectedRowId(galleryId);
    dispatch(galleryDetailedList.get({galleryRef: galleryId})).then((detailedGallery) => {
      dispatch(setSelectedGallery(detailedGallery));
    });
  };

  useEffect(() => {
    if (hasAutoSelectedFirstGallery.current) {
      return;
    }
    const firstRow = head(galleries_excluding_photoart);
    const firstRowId = get(firstRow, "id");
    const galleryExists = !isEmpty(galleries_excluding_photoart) && firstRowId
    if (galleryExists) {
      hasAutoSelectedFirstGallery.current = true;
      setSelectedRowId(firstRowId);
      dispatch(galleryDetailedList.get({galleryRef: firstRowId})).then((detailedGallery) => {
        dispatch(setSelectedGallery(detailedGallery));
      });
    }
  }, [galleries_excluding_photoart]);

  useEffect(() => {
    if (selectedGallery && get(selectedGallery, 'id') !== selectedRowId) {
      setSelectedRowId(get(selectedGallery, 'id'))
    }
  }, [selectedGallery])

  const onSelectGallery = (gallery_id) => {
    history.push(`/photographer/gallery/${gallery_id}/view`);
  };

  return (
    <TableContainer component={Paper} className={classes.container}>
      <AddressSearch />
      {(isBusy || loadingGalleries) && <LoadingSpinner />}
      <SideBarGalleryFilter />

      <div className={classes.tableWrap}>
        <Table size="medium" aria-label="customized table">
          <TableHead>
            <StyledTableRow>
              <StyledTableCell style={{ width: 140, whiteSpace: "nowrap", paddingLeft: 24 }}>
                Date
              </StyledTableCell>
              <StyledTableCell style={{ width: "30%", minWidth: 200 }}>Gallery Name</StyledTableCell>
              <StyledTableCell style={{ width: 80, textAlign: "center" }}>Photos</StyledTableCell>
              <StyledTableCell style={{ width: "32%" }}>Event</StyledTableCell>
              <StyledTableCell style={{ width: 44, textAlign: "right" }}>Actions</StyledTableCell>
            </StyledTableRow>
          </TableHead>
          <TableBody>
            {galleries_excluding_photoart.map((row, index) => (
              <StyledTableRow
                hover
                className={
                  get(row, "available_to_purchase")
                    ? ""
                    : "unavailable"
                }
                key={`${row.id}-styledrow`}
                selected={selectedRowId === row.id}
                onClick={() => {
                  selectGalleryWithDetail(row.id);
                }}
              >
                <StyledTableCell component="th" scope="row" className={classes.dateCell}>
                  {moment.utc(get(row, "shot_at_datetime")).format("Do MMM YYYY")}
                </StyledTableCell>
                <StyledTableCell className={classes.nameCell}>
                  {get(row, "session_name")}
                </StyledTableCell>
                <StyledTableCell>
                  {get(row, "number_of_photos_in_gallery")}
                </StyledTableCell>
                <StyledTableCell>
                  {get(row, "gallery_event_name", "N/A")}
                </StyledTableCell>
                <StyledTableCell>
                  <SelectRow
                    row={row}
                    history={history}
                    dispatch={dispatch}
                    key={`${row.id}-selectrow`}
                    onDeleted={onDeleteSelectedGallery}
                    onAvailableToPurchase={onAvailableToPurchaseSelectedGallery}
                    onUnavailableToPurchase={
                      onUnavailableToPurchaseSelectedGallery
                    }
                  />
                </StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </div>
      <Pagination item_list={galleryList} />
    </TableContainer>
  );
};

export default AllGalleries;
